import {toast} from 'react-toastify';

export const notify = toast;
